import { accountAnalyticsAction, accountEventsAttached } from '../actions/accountActions';
import { generate } from '@core/js/utils/componentUtils';
import { init as rrInit } from '@core/js/components/richRelevanceComponent';
import { init as accountNavInit } from '@core/js/components/accountNavComponent';
import { getDefaultOptions } from '@core/js/utils/a15componentUtils';

import template from 'partials/account-recommendations.j2';

export function init(store, overrides = {}) {
    const placementKey = 'account';

    const config = {
        name: 'accountComponent',
        attachEvents: attachEvents,
        loader: {
            onWindow: true
        },
        children: [
            [rrInit, {
                templateLocation: '.dom-account-recommendations',
                template: template,
                name: 'accountRecommendationsComponent',
                watch: [`core.rrRecs.${placementKey}.recs`, 'core.deviceCharacteristics']
            }],
            [accountNavInit, {}]
        ],
    };
    return generate(config, store, overrides, getDefaultOptions(store));
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on('touchend click', '[data-cm-element]', (e) => {
        store.dispatch(accountAnalyticsAction(e));
    });

    $(document).on('ATTACH_LOADER', (e) => {
        this.attachLoader(store);
    });

    $(document).on('REMOVE_LOADER', (e) => {
        this.removeLoader(store);
    });

    store.dispatch(accountEventsAttached());
}
